<div [formGroup]="frm">
    <angular-editor [formControlName]="formControlName" [config]="editorConfig"></angular-editor>
</div>
